import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Glyphs from "../../ReactViews/Custom/Chart/Glyphs";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import MappableTraits from "./MappableTraits";
const availableChartGlyphStyles = Object.keys(Glyphs).join(", ");
let ChartTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Chart type",
  description: "Type determines how the data availibility will be plotted on chart. eg: momentLines, momentPoints"
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Chart Disclaimer",
  description: "A HTML string to show above the chart as a disclaimer"
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Chart color",
  description: "The color to use when the data set is displayed on the chart. The value can be any html color string, eg: 'cyan' or '#00ffff' or 'rgba(0, 255, 255, 1)' for the color cyan."
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Chart glyph style",
  description: "The glyph style to use for points plotted on the chart. Allowed values include ".concat(availableChartGlyphStyles, ". Default is \"circle\".")
}), _class = class ChartTraits extends mixTraits(MappableTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "chartType", _descriptor, this);
    // This trait proabably doesn't belong here and should instead be on a new
    //  trait class ChartTraits, however there are complexities to changing
    //  chart-related traits, mixins and interfaces to support this change.
    _initializerDefineProperty(this, "chartDisclaimer", _descriptor2, this);
    _initializerDefineProperty(this, "chartColor", _descriptor3, this);
    _initializerDefineProperty(this, "chartGlyphStyle", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "chartType", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "chartDisclaimer", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "chartColor", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "chartGlyphStyle", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ChartTraits as default };